import React, { useState, useRef, useEffect } from "react";
import { getPollDetails } from "../api/polls";
import DashboardHeader from "../components/Other/DashboardHeader";
import PageContainer from "../components/pages/PageContainer";
import { useParams } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import Loader from "../components/Loader";
import { useTranslation } from "react-i18next";
import CustomPageHeader from "../components/pages/CustomPageHeader";

const PollDetails = () => {
  const { id: poll_id } = useParams();
  const { t } = useTranslation();
  const [votes, setVotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(null);

  const requestInProgress = useRef(false);
  const observerRef = useRef(null);
  const loaderRef = useRef(null);

  // Fetch paginated votes
  useEffect(() => {
    if (requestInProgress.current) return;

    requestInProgress.current = true;
    setLoading(true);
    setError("");

    getPollDetails(poll_id, page)
      .then((res) => {
        const newVotes = Array.isArray(res?.data?.data) ? res.data.data : [];
        const apiLastPage = Number(res?.data?.last_page || 1);

        setVotes((prev) => {
          if (page === 1) return newVotes;
          const ids = new Set(prev.map((v) => v.id));
          const filtered = newVotes.filter((v) => !ids.has(v.id));
          return [...prev, ...filtered];
        });

        setLastPage(apiLastPage);
      })
      .catch((err) => {
        setError(err.message || "Failed to fetch poll details");
      })
      .finally(() => {
        setLoading(false);
        requestInProgress.current = false;
      });
  }, [poll_id, page]);

  // Infinite scroll observer
  useEffect(() => {
    if (!loaderRef.current) return;

    if (observerRef.current) observerRef.current.disconnect();

    observerRef.current = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        const noMorePages = lastPage !== null && page >= lastPage;

        if (
          entry.isIntersecting &&
          !loading &&
          !requestInProgress.current &&
          !noMorePages
        ) {
          setPage((prev) => prev + 1);
        }
      },
      { root: null, rootMargin: "200px", threshold: 0 }
    );

    observerRef.current.observe(loaderRef.current);

    return () => {
      if (observerRef.current) observerRef.current.disconnect();
    };
  }, [loading, lastPage, page]);

  return (
    <>
      <CustomPageHeader
        pageContainerClass="px-2 w-full mx-w-4xl"
        title={t("poll_detail", "Vibelinks")}
      >
        {/* <div style={{ position: "relative", minHeight: "60px" }}> */}
        {/* Back Arrow */}
        {/* <button
            onClick={() => navigate("/polls-list")}
            style={{
              position: "absolute",
              top: 8,
              left: 8,
              background: "#fff",
              borderRadius: "50%",
              padding: 8,
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              zIndex: 10,
              border: "none",
              cursor: "pointer",
            }}
          >
            <FontAwesomeIcon icon={faArrowLeft} size="lg" color="#333" />
          </button> */}
        {/* </div> */}

        <div className="mt-6 space-y-3">
          {error && <div className="text-red-500 text-center">{error}</div>}

          {votes.length > 0
            ? votes.map((vote) => (
                <div
                  key={vote.id}
                  className="flex items-center bg-white rounded-lg shadow p-3 gap-4"
                >
                  <img
                    src={vote.user?.image || "/vibe_newlogo.png"}
                    alt={vote.user?.full_name || "User"}
                    className="w-10 h-10 rounded-full"
                  />
                  <div className="flex-1">
                    <div className="font-semibold text-gray-800">
                      {vote.user?.full_name ||
                        vote.user?.user_name ||
                        vote.user?.email ||
                        "User"}
                    </div>
                    <div className="text-gray-500">
                      {t("voted_for")}{" "}
                      <span className="font-bold text-[#6d29f6]">
                        {vote.poll_option?.option || ""}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            : !loading && (
                <div className="text-gray-500">{t("no_vote_yet")}</div>
              )}

          {/* Loading Spinner */}
          {loading && <Loader />}

          {/* End Message */}
          {/* {!hasMore && !loading && votes.length > 0 && (
            <div className="text-center text-gray-400 text-sm">No more votes</div>
          )} */}

          {/* Sentinel for infinite scroll */}
          <div ref={loaderRef} className="h-1" />
        </div>
      </CustomPageHeader>
    </>
  );
};

export default PollDetails;
